import React, { FC } from 'react';
import { Box, Grid } from '@material-ui/core';

import { LeaderboardConfigFragment, useGetUserLeaderboardQuery } from 'api';
import { EmptyState, Loaders } from 'components';
import { useNotify } from 'hooks';

import { useGetLeaderboardScores } from '../hooks';

import LeaderboardHeader from '../components/Header';
import LeaderboardTable from '../components/Table';
import LeaderboardLoader from '../components/Loader';

interface Props {
  config: LeaderboardConfigFragment;
}

const Leaderboard: FC<Props> = ({ config }) => {
  const notify = useNotify();

  const queryResult = useGetUserLeaderboardQuery(
    {
      leaderboard_config_id: config.id,
    },
    {
      enabled: !!config,
      onError: notify.queryError,
    }
  );

  const userScore = queryResult?.data?.getLeaderboardForUser?.user_score ?? null;

  const { results, isEmpty, isExhausted, isInitialLoad, sentinelRef } = useGetLeaderboardScores(
    {
      leaderboard_config_id: config.id,
    },
    {
      enabled: !!config,
    }
  );

  if (isInitialLoad) {
    return <LeaderboardLoader />;
  }

  function renderBody() {
    if (isEmpty) {
      return (
        <Box marginTop={5}>
          <EmptyState name="leaderboard" />
        </Box>
      );
    }

    return (
      <Grid item>
        <LeaderboardTable items={results} />
        {!isExhausted && (
          <div ref={sentinelRef}>
            <Loaders.Standard />
          </div>
        )}
      </Grid>
    );
  }

  return (
    <Grid container direction="column" wrap="nowrap" spacing={2}>
      <Grid item>
        <LeaderboardHeader config={config} userScore={userScore} />
      </Grid>
      {renderBody()}
    </Grid>
  );
};

Leaderboard.defaultProps = {
  // @ts-ignore
  config: {},
};

export default Leaderboard;
